/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: t4zZariOuyPw
import * as React from "react";
import {
  PlasmicImg as PlasmicImg__,
  PlasmicLink as PlasmicLink__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  set as $stateSet,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import AppShell from "../../AppShell"; // plasmic-import: Apa7akI9fuQs/component
import TabLayout from "../../TabLayout"; // plasmic-import: 0i0g7bSenwRJ/component
import Sidenav from "../../Sidenav"; // plasmic-import: gQC3DIuIxMM-/component
import ModuleNav from "../../ModuleNav"; // plasmic-import: wOh_p_z-r3kg/component
import ButtonNav from "../../ButtonNav"; // plasmic-import: n-yL9NcVDVDg/component
import ButtonTab from "../../ButtonTab"; // plasmic-import: Z8Sy7rP6ZFXR/component
import PageLayout from "../../PageLayout"; // plasmic-import: 6gaQHJJIqual/component
import Topnav from "../../Topnav"; // plasmic-import: 0fErs5Rt_giR/component
import LeftSectionNav from "../../LeftSectionNav"; // plasmic-import: LqMwNzsXjkO-/component
import SeparatorHorizontal from "../../SeparatorHorizontal"; // plasmic-import: vjwl8iKCk0Vg/component
import HeadingStatus from "../../HeadingStatus"; // plasmic-import: _vaOWs1BI32D/component
import InputFormShell from "../../InputFormShell"; // plasmic-import: e3sNvwGa9YkJ/component
import FormElement from "../../FormElement"; // plasmic-import: SrXOXPt7amu2/component
import InputFieldUnderline from "../../InputFieldUnderline"; // plasmic-import: OhTzEj1YMg6z/component
import Textarea from "../../Textarea"; // plasmic-import: vEnSX2sF6UOQ/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicWebSupport.module.css"; // plasmic-import: t4zZariOuyPw/css
import Icon12Icon from "./icons/PlasmicIcon__Icon12"; // plasmic-import: H2aWiH48hSbz/icon
import Icon4Icon from "./icons/PlasmicIcon__Icon4"; // plasmic-import: ErJNYa-REKSk/icon
import image2RcDhf2RmVmG from "./images/image2.svg"; // plasmic-import: RcDhf_2RMVmG/picture
import image183TIq2GJx3VUp from "./images/image18.svg"; // plasmic-import: 3tIq2GJx3vUP/picture

createPlasmicElementProxy;

export const PlasmicWebSupport__VariantProps = new Array();

export const PlasmicWebSupport__ArgProps = new Array();

const $$ = {};

function PlasmicWebSupport__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "isFormSubmited",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $ctx }) => false
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"pageSupport"}
        data-plasmic-override={overrides.pageSupport}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          projectcss.all,
          projectcss.root_reset,
          projectcss.plasmic_default_styles,
          projectcss.plasmic_mixins,
          styleTokensClassNames,
          sty.pageSupport
        )}
      >
        <AppShell
          data-plasmic-name={"appShell"}
          data-plasmic-override={overrides.appShell}
          appShell={
            <TabLayout
              data-plasmic-name={"tabLayout"}
              data-plasmic-override={overrides.tabLayout}
              className={classNames("__wab_instance", sty.tabLayout)}
              layoutType={"horizontalStacked"}
              tabContent={
                <PageLayout
                  data-plasmic-name={"pageLayout"}
                  data-plasmic-override={overrides.pageLayout}
                  className={classNames("__wab_instance", sty.pageLayout)}
                  layoutSections={"withNav"}
                  pageContent={
                    <div
                      data-plasmic-name={"supportPageContentWrapper"}
                      data-plasmic-override={
                        overrides.supportPageContentWrapper
                      }
                      className={classNames(
                        projectcss.all,
                        sty.supportPageContentWrapper
                      )}
                    >
                      <div
                        className={classNames(
                          projectcss.all,
                          sty.freeBox__gdNuP
                        )}
                      >
                        <HeadingStatus
                          data-plasmic-name={"headingStatus"}
                          data-plasmic-override={overrides.headingStatus}
                          isSubmitedSuccessfully={(() => {
                            try {
                              return $state.isFormSubmited;
                            } catch (e) {
                              if (
                                e instanceof TypeError ||
                                e?.plasmicType === "PlasmicUndefinedDataError"
                              ) {
                                return [];
                              }
                              throw e;
                            }
                          })()}
                        />

                        <div
                          className={classNames(
                            projectcss.all,
                            sty.freeBox__vvCuf
                          )}
                        >
                          <InputFormShell
                            data-plasmic-name={"inputFormShell"}
                            data-plasmic-override={overrides.inputFormShell}
                            className={classNames(
                              "__wab_instance",
                              sty.inputFormShell
                            )}
                            fieldsSlot={
                              <FormElement
                                data-plasmic-name={"formElement"}
                                data-plasmic-override={overrides.formElement}
                                className={classNames(
                                  "__wab_instance",
                                  sty.formElement
                                )}
                                formInputComponent={
                                  <div
                                    data-plasmic-name={"supportFormWrapper2"}
                                    data-plasmic-override={
                                      overrides.supportFormWrapper2
                                    }
                                    className={classNames(
                                      projectcss.all,
                                      sty.supportFormWrapper2
                                    )}
                                  >
                                    <div
                                      data-plasmic-name={"floatyWrapper5"}
                                      data-plasmic-override={
                                        overrides.floatyWrapper5
                                      }
                                      className={classNames(
                                        projectcss.all,
                                        sty.floatyWrapper5
                                      )}
                                    >
                                      <div
                                        data-plasmic-name={"inlineTextWrapp6"}
                                        data-plasmic-override={
                                          overrides.inlineTextWrapp6
                                        }
                                        className={classNames(
                                          projectcss.all,
                                          sty.inlineTextWrapp6
                                        )}
                                      >
                                        <div
                                          className={classNames(
                                            projectcss.all,
                                            projectcss.__wab_text,
                                            sty.text__pYgbc
                                          )}
                                        >
                                          {"I'm"}
                                        </div>
                                      </div>
                                      <InputFieldUnderline
                                        className={classNames(
                                          "__wab_instance",
                                          sty.inputFieldUnderline__iqpSr
                                        )}
                                        inputName={"inquirerName"}
                                        onSurface={"onGrey"}
                                        padding={"noPadding"}
                                        placeholder={'"John Smith"'}
                                        required={true}
                                        status={"normal"}
                                        type={"text"}
                                      />
                                    </div>
                                    <div
                                      className={classNames(
                                        projectcss.all,
                                        sty.freeBox__gFOg
                                      )}
                                    >
                                      <div
                                        className={classNames(
                                          projectcss.all,
                                          sty.freeBox___5MKqm
                                        )}
                                      >
                                        <div
                                          data-plasmic-name={"textareaWrapp2"}
                                          data-plasmic-override={
                                            overrides.textareaWrapp2
                                          }
                                          className={classNames(
                                            projectcss.all,
                                            sty.textareaWrapp2
                                          )}
                                        >
                                          <Textarea
                                            data-plasmic-name={"textarea"}
                                            data-plasmic-override={
                                              overrides.textarea
                                            }
                                            className={classNames(
                                              "__wab_instance",
                                              sty.textarea
                                            )}
                                            fixedLayout={"large"}
                                            inputName={"inquirerMessage"}
                                            placeholder={"message..."}
                                            radius={"halfModule"}
                                            required={true}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div
                                      data-plasmic-name={"floatyWrapper6"}
                                      data-plasmic-override={
                                        overrides.floatyWrapper6
                                      }
                                      className={classNames(
                                        projectcss.all,
                                        sty.floatyWrapper6
                                      )}
                                    >
                                      <div
                                        data-plasmic-name={"inlineTextWrapp7"}
                                        data-plasmic-override={
                                          overrides.inlineTextWrapp7
                                        }
                                        className={classNames(
                                          projectcss.all,
                                          sty.inlineTextWrapp7
                                        )}
                                      >
                                        <div
                                          className={classNames(
                                            projectcss.all,
                                            projectcss.__wab_text,
                                            sty.text__dekO7
                                          )}
                                        >
                                          {
                                            "and I\u2019d like to continue this conversation at\r"
                                          }
                                        </div>
                                      </div>
                                      <InputFieldUnderline
                                        className={classNames(
                                          "__wab_instance",
                                          sty.inputFieldUnderline__tv8O
                                        )}
                                        inputName={"inquirerEmail"}
                                        onSurface={"onGrey"}
                                        padding={"noPadding"}
                                        placeholder={'"my.email@example.com"'}
                                        required={true}
                                        status={"normal"}
                                        type={"email"}
                                      />

                                      <div
                                        data-plasmic-name={"inlineTextWrapp8"}
                                        data-plasmic-override={
                                          overrides.inlineTextWrapp8
                                        }
                                        className={classNames(
                                          projectcss.all,
                                          sty.inlineTextWrapp8
                                        )}
                                      >
                                        <div
                                          className={classNames(
                                            projectcss.all,
                                            projectcss.__wab_text,
                                            sty.text___3Ddps
                                          )}
                                        >
                                          <React.Fragment>
                                            <React.Fragment>
                                              {"[ "}
                                            </React.Fragment>
                                            {
                                              <PlasmicLink__
                                                className={classNames(
                                                  projectcss.all,
                                                  projectcss.a,
                                                  projectcss.__wab_text,
                                                  projectcss.plasmic_default__inline,
                                                  sty.link__brWas
                                                )}
                                                name={"webInqSendButton"}
                                                onClick={async event => {
                                                  const $steps = {};
                                                  $steps[
                                                    "updateIsFormSubmited"
                                                  ] = true
                                                    ? (() => {
                                                        const actionArgs = {
                                                          variable: {
                                                            objRoot: $state,
                                                            variablePath: [
                                                              "isFormSubmited"
                                                            ]
                                                          },
                                                          operation: 0,
                                                          value: true
                                                        };
                                                        return (({
                                                          variable,
                                                          value,
                                                          startIndex,
                                                          deleteCount
                                                        }) => {
                                                          if (!variable) {
                                                            return;
                                                          }
                                                          const {
                                                            objRoot,
                                                            variablePath
                                                          } = variable;
                                                          $stateSet(
                                                            objRoot,
                                                            variablePath,
                                                            value
                                                          );
                                                          return value;
                                                        })?.apply(null, [
                                                          actionArgs
                                                        ]);
                                                      })()
                                                    : undefined;
                                                  if (
                                                    $steps[
                                                      "updateIsFormSubmited"
                                                    ] != null &&
                                                    typeof $steps[
                                                      "updateIsFormSubmited"
                                                    ] === "object" &&
                                                    typeof $steps[
                                                      "updateIsFormSubmited"
                                                    ].then === "function"
                                                  ) {
                                                    $steps[
                                                      "updateIsFormSubmited"
                                                    ] =
                                                      await $steps[
                                                        "updateIsFormSubmited"
                                                      ];
                                                  }
                                                }}
                                                platform={"react"}
                                              >
                                                {"send"}
                                              </PlasmicLink__>
                                            }
                                            <React.Fragment>
                                              {" ]"}
                                            </React.Fragment>
                                          </React.Fragment>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                }
                                helperText={
                                  "Bro, pls! a way that accomplishes a desired aim or result. in a way that accomplishes a "
                                }
                                label={``}
                                showFormElement={true}
                                showHelperText={false}
                                status={"error"}
                              />
                            }
                            layout={"oneBox"}
                          />
                        </div>
                      </div>
                      <div
                        className={classNames(
                          projectcss.all,
                          projectcss.__wab_text,
                          sty.text__qgKhV
                        )}
                      >
                        {"ask@opformypractice.com"}
                      </div>
                    </div>
                  }
                  pageNav={
                    <React.Fragment>
                      <Topnav
                        data-plasmic-name={"topnav"}
                        data-plasmic-override={overrides.topnav}
                        className={classNames("__wab_instance", sty.topnav)}
                        layoutType={"titleButtons"}
                        pageButtons={
                          <div
                            data-plasmic-name={"actionCell"}
                            data-plasmic-override={overrides.actionCell}
                            className={classNames(
                              projectcss.all,
                              sty.actionCell
                            )}
                          >
                            <div
                              className={classNames(
                                projectcss.all,
                                projectcss.__wab_text,
                                sty.text__gKga
                              )}
                            >
                              <React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span"
                                  }
                                  style={{ color: "var(--token-jyNQAasUGv4X)" }}
                                >
                                  {"[ "}
                                </span>
                                <React.Fragment>{""}</React.Fragment>
                                {
                                  <PlasmicLink__
                                    className={classNames(
                                      projectcss.all,
                                      projectcss.a,
                                      projectcss.__wab_text,
                                      projectcss.plasmic_default__inline,
                                      sty.link___8MiYv
                                    )}
                                    href={`/login`}
                                    platform={"react"}
                                  >
                                    <React.Fragment>
                                      <span
                                        className={
                                          "plasmic_default__all plasmic_default__span"
                                        }
                                        style={{
                                          color: "var(--token-jyNQAasUGv4X)"
                                        }}
                                      >
                                        {"sign up"}
                                      </span>
                                    </React.Fragment>
                                  </PlasmicLink__>
                                }
                                <React.Fragment>{""}</React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span"
                                  }
                                  style={{ color: "var(--token-jyNQAasUGv4X)" }}
                                >
                                  {" ]"}
                                </span>
                                <React.Fragment>{""}</React.Fragment>
                                <span
                                  className={
                                    "plasmic_default__all plasmic_default__span"
                                  }
                                  style={{ color: "var(--token-zNwZnKG8CPMa)" }}
                                >
                                  {"\u00a0 for live conversation instead."}
                                </span>
                              </React.Fragment>
                            </div>
                          </div>
                        }
                        pageTitle={
                          <LeftSectionNav
                            data-plasmic-name={"leftSectionNav"}
                            data-plasmic-override={overrides.leftSectionNav}
                            className={classNames(
                              "__wab_instance",
                              sty.leftSectionNav
                            )}
                            currentPageTitle={"support."}
                            topNav={"titleAndOneCrumb"}
                          >
                            {"compass."}
                          </LeftSectionNav>
                        }
                      />

                      <SeparatorHorizontal
                        data-plasmic-name={"separatorHorizontal"}
                        data-plasmic-override={overrides.separatorHorizontal}
                        className={classNames(
                          "__wab_instance",
                          sty.separatorHorizontal
                        )}
                      />
                    </React.Fragment>
                  }
                />
              }
              tabNav={
                <Sidenav
                  data-plasmic-name={"sidenav"}
                  data-plasmic-override={overrides.sidenav}
                  backButton={
                    <ModuleNav
                      className={classNames(
                        "__wab_instance",
                        sty.moduleNav__wj8Mu
                      )}
                      navButtonSlot={
                        <ButtonNav
                          className={classNames(
                            "__wab_instance",
                            sty.buttonNav__ohtQq
                          )}
                          color={"greyTwo"}
                          iconForButton={
                            <PlasmicImg__
                              alt={""}
                              className={classNames(sty.img__azbBd)}
                              displayHeight={"100%"}
                              displayMaxHeight={"none"}
                              displayMaxWidth={"none"}
                              displayMinHeight={"0"}
                              displayMinWidth={"0"}
                              displayWidth={"100%"}
                              loading={"lazy"}
                              src={{
                                src: image183TIq2GJx3VUp,
                                fullWidth: 20,
                                fullHeight: 20,
                                aspectRatio: undefined
                              }}
                            />
                          }
                          onClick={async () => {
                            const $steps = {};
                            $steps["goToWebHome"] = true
                              ? (() => {
                                  const actionArgs = { destination: `/home` };
                                  return (({ destination }) => {
                                    if (
                                      typeof destination === "string" &&
                                      destination.startsWith("#")
                                    ) {
                                      document
                                        .getElementById(destination.substr(1))
                                        .scrollIntoView({ behavior: "smooth" });
                                    } else {
                                      location.assign(destination);
                                    }
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["goToWebHome"] != null &&
                              typeof $steps["goToWebHome"] === "object" &&
                              typeof $steps["goToWebHome"].then === "function"
                            ) {
                              $steps["goToWebHome"] =
                                await $steps["goToWebHome"];
                            }
                          }}
                          shape={"globalRounding"}
                          status={"normal"}
                        />
                      }
                    />
                  }
                  className={classNames("__wab_instance", sty.sidenav)}
                  layoutType={"_default"}
                  logo={
                    <ModuleNav
                      navButtonSlot={
                        <ButtonNav
                          className={classNames(
                            "__wab_instance",
                            sty.buttonNav___8Dukb
                          )}
                          color={"white"}
                          iconForButton={
                            <PlasmicImg__
                              alt={""}
                              className={classNames(sty.img___8JQm)}
                              displayHeight={"100%"}
                              displayMaxHeight={"none"}
                              displayMaxWidth={"none"}
                              displayMinHeight={"0"}
                              displayMinWidth={"0"}
                              displayWidth={"100%"}
                              loading={"lazy"}
                              src={{
                                src: image2RcDhf2RmVmG,
                                fullWidth: 256,
                                fullHeight: 256,
                                aspectRatio: 1
                              }}
                            />
                          }
                          onClick={async () => {
                            const $steps = {};
                            $steps["goToHomepage"] = true
                              ? (() => {
                                  const actionArgs = { destination: `/` };
                                  return (({ destination }) => {
                                    if (
                                      typeof destination === "string" &&
                                      destination.startsWith("#")
                                    ) {
                                      document
                                        .getElementById(destination.substr(1))
                                        .scrollIntoView({ behavior: "smooth" });
                                    } else {
                                      location.assign(destination);
                                    }
                                  })?.apply(null, [actionArgs]);
                                })()
                              : undefined;
                            if (
                              $steps["goToHomepage"] != null &&
                              typeof $steps["goToHomepage"] === "object" &&
                              typeof $steps["goToHomepage"].then === "function"
                            ) {
                              $steps["goToHomepage"] =
                                await $steps["goToHomepage"];
                            }
                          }}
                          shape={"fullRounding"}
                          slotSize={"fillButton"}
                          status={"normal"}
                        />
                      }
                    />
                  }
                  tabs={
                    <React.Fragment>
                      <ButtonTab
                        className={classNames(
                          "__wab_instance",
                          sty.buttonTab__uliwQ
                        )}
                        iconTab={
                          <Icon12Icon
                            className={classNames(
                              projectcss.all,
                              sty.svg___2PQni
                            )}
                            role={"img"}
                          />
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebCompass"] = true
                            ? (() => {
                                const actionArgs = { destination: `/compass` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebCompass"] != null &&
                            typeof $steps["goToWebCompass"] === "object" &&
                            typeof $steps["goToWebCompass"].then === "function"
                          ) {
                            $steps["goToWebCompass"] =
                              await $steps["goToWebCompass"];
                          }
                        }}
                        type={"_default"}
                      />

                      <ButtonTab
                        iconTab={
                          <Icon4Icon
                            className={classNames(
                              projectcss.all,
                              sty.svg__e7Umq
                            )}
                            role={"img"}
                          />
                        }
                        onClick={async () => {
                          const $steps = {};
                          $steps["goToWebSupport"] = true
                            ? (() => {
                                const actionArgs = { destination: `/support` };
                                return (({ destination }) => {
                                  if (
                                    typeof destination === "string" &&
                                    destination.startsWith("#")
                                  ) {
                                    document
                                      .getElementById(destination.substr(1))
                                      .scrollIntoView({ behavior: "smooth" });
                                  } else {
                                    location.assign(destination);
                                  }
                                })?.apply(null, [actionArgs]);
                              })()
                            : undefined;
                          if (
                            $steps["goToWebSupport"] != null &&
                            typeof $steps["goToWebSupport"] === "object" &&
                            typeof $steps["goToWebSupport"].then === "function"
                          ) {
                            $steps["goToWebSupport"] =
                              await $steps["goToWebSupport"];
                          }
                        }}
                        type={"withLine"}
                      />
                    </React.Fragment>
                  }
                />
              }
            />
          }
          className={classNames("__wab_instance", sty.appShell)}
          layoutType={"_default"}
        />
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  pageSupport: [
    "pageSupport",
    "appShell",
    "tabLayout",
    "sidenav",
    "pageLayout",
    "topnav",
    "actionCell",
    "leftSectionNav",
    "separatorHorizontal",
    "supportPageContentWrapper",
    "headingStatus",
    "inputFormShell",
    "formElement",
    "supportFormWrapper2",
    "floatyWrapper5",
    "inlineTextWrapp6",
    "textareaWrapp2",
    "textarea",
    "floatyWrapper6",
    "inlineTextWrapp7",
    "inlineTextWrapp8"
  ],

  appShell: [
    "appShell",
    "tabLayout",
    "sidenav",
    "pageLayout",
    "topnav",
    "actionCell",
    "leftSectionNav",
    "separatorHorizontal",
    "supportPageContentWrapper",
    "headingStatus",
    "inputFormShell",
    "formElement",
    "supportFormWrapper2",
    "floatyWrapper5",
    "inlineTextWrapp6",
    "textareaWrapp2",
    "textarea",
    "floatyWrapper6",
    "inlineTextWrapp7",
    "inlineTextWrapp8"
  ],

  tabLayout: [
    "tabLayout",
    "sidenav",
    "pageLayout",
    "topnav",
    "actionCell",
    "leftSectionNav",
    "separatorHorizontal",
    "supportPageContentWrapper",
    "headingStatus",
    "inputFormShell",
    "formElement",
    "supportFormWrapper2",
    "floatyWrapper5",
    "inlineTextWrapp6",
    "textareaWrapp2",
    "textarea",
    "floatyWrapper6",
    "inlineTextWrapp7",
    "inlineTextWrapp8"
  ],

  sidenav: ["sidenav"],
  pageLayout: [
    "pageLayout",
    "topnav",
    "actionCell",
    "leftSectionNav",
    "separatorHorizontal",
    "supportPageContentWrapper",
    "headingStatus",
    "inputFormShell",
    "formElement",
    "supportFormWrapper2",
    "floatyWrapper5",
    "inlineTextWrapp6",
    "textareaWrapp2",
    "textarea",
    "floatyWrapper6",
    "inlineTextWrapp7",
    "inlineTextWrapp8"
  ],

  topnav: ["topnav", "actionCell", "leftSectionNav"],
  actionCell: ["actionCell"],
  leftSectionNav: ["leftSectionNav"],
  separatorHorizontal: ["separatorHorizontal"],
  supportPageContentWrapper: [
    "supportPageContentWrapper",
    "headingStatus",
    "inputFormShell",
    "formElement",
    "supportFormWrapper2",
    "floatyWrapper5",
    "inlineTextWrapp6",
    "textareaWrapp2",
    "textarea",
    "floatyWrapper6",
    "inlineTextWrapp7",
    "inlineTextWrapp8"
  ],

  headingStatus: ["headingStatus"],
  inputFormShell: [
    "inputFormShell",
    "formElement",
    "supportFormWrapper2",
    "floatyWrapper5",
    "inlineTextWrapp6",
    "textareaWrapp2",
    "textarea",
    "floatyWrapper6",
    "inlineTextWrapp7",
    "inlineTextWrapp8"
  ],

  formElement: [
    "formElement",
    "supportFormWrapper2",
    "floatyWrapper5",
    "inlineTextWrapp6",
    "textareaWrapp2",
    "textarea",
    "floatyWrapper6",
    "inlineTextWrapp7",
    "inlineTextWrapp8"
  ],

  supportFormWrapper2: [
    "supportFormWrapper2",
    "floatyWrapper5",
    "inlineTextWrapp6",
    "textareaWrapp2",
    "textarea",
    "floatyWrapper6",
    "inlineTextWrapp7",
    "inlineTextWrapp8"
  ],

  floatyWrapper5: ["floatyWrapper5", "inlineTextWrapp6"],
  inlineTextWrapp6: ["inlineTextWrapp6"],
  textareaWrapp2: ["textareaWrapp2", "textarea"],
  textarea: ["textarea"],
  floatyWrapper6: ["floatyWrapper6", "inlineTextWrapp7", "inlineTextWrapp8"],
  inlineTextWrapp7: ["inlineTextWrapp7"],
  inlineTextWrapp8: ["inlineTextWrapp8"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicWebSupport__ArgProps,
          internalVariantPropNames: PlasmicWebSupport__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicWebSupport__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "pageSupport") {
    func.displayName = "PlasmicWebSupport";
  } else {
    func.displayName = `PlasmicWebSupport.${nodeName}`;
  }
  return func;
}

export const PlasmicWebSupport = Object.assign(
  // Top-level PlasmicWebSupport renders the root element
  makeNodeComponent("pageSupport"),
  {
    // Helper components rendering sub-elements
    appShell: makeNodeComponent("appShell"),
    tabLayout: makeNodeComponent("tabLayout"),
    sidenav: makeNodeComponent("sidenav"),
    pageLayout: makeNodeComponent("pageLayout"),
    topnav: makeNodeComponent("topnav"),
    actionCell: makeNodeComponent("actionCell"),
    leftSectionNav: makeNodeComponent("leftSectionNav"),
    separatorHorizontal: makeNodeComponent("separatorHorizontal"),
    supportPageContentWrapper: makeNodeComponent("supportPageContentWrapper"),
    headingStatus: makeNodeComponent("headingStatus"),
    inputFormShell: makeNodeComponent("inputFormShell"),
    formElement: makeNodeComponent("formElement"),
    supportFormWrapper2: makeNodeComponent("supportFormWrapper2"),
    floatyWrapper5: makeNodeComponent("floatyWrapper5"),
    inlineTextWrapp6: makeNodeComponent("inlineTextWrapp6"),
    textareaWrapp2: makeNodeComponent("textareaWrapp2"),
    textarea: makeNodeComponent("textarea"),
    floatyWrapper6: makeNodeComponent("floatyWrapper6"),
    inlineTextWrapp7: makeNodeComponent("inlineTextWrapp7"),
    inlineTextWrapp8: makeNodeComponent("inlineTextWrapp8"),
    // Metadata about props expected for PlasmicWebSupport
    internalVariantProps: PlasmicWebSupport__VariantProps,
    internalArgProps: PlasmicWebSupport__ArgProps,
    // Page metadata
    pageMetadata: {
      title: "OP | support.",
      description: "",
      ogImageSrc: "",
      canonical: ""
    }
  }
);

export default PlasmicWebSupport;
/* prettier-ignore-end */
